/**
 * Come mostrare l'anteprima di un PDF: con il lettore del browser in un
 * riquadro ("iframe") o disegnandolo noi con pdf.js ("pdfjs").
 *
 * Sui telefoni e sui tablet il lettore di sistema, dentro un riquadro, non
 * adatta la pagina alla larghezza: su iPhone la mostra alla sua misura
 * naturale e la taglia a destra. Li' si disegna con pdf.js, pagina adattata
 * alla larghezza e scorrimento verticale. Sul desktop il lettore del browser
 * funziona e resta quello. Le immagini diventate PDF vanno sempre con pdf.js.
 */

import { isRasterImageFilename } from "./pdfFitUtils";

/** Telefono o tablet, compreso l'iPad che si presenta come un Mac. */
export function dispositivoTouch({ userAgent = "", platform = "", maxTouchPoints = 0 } = {}) {
  if (/iPhone|iPad|iPod|Android/i.test(userAgent)) return true;
  return platform === "MacIntel" && maxTouchPoints > 1;
}

export function dispositivoAttuale() {
  if (typeof navigator === "undefined") return {};
  return {
    userAgent: navigator.userAgent || "",
    platform: navigator.platform || "",
    maxTouchPoints: navigator.maxTouchPoints || 0,
  };
}

export function modoAnteprima(nomeOriginale, dispositivo = dispositivoAttuale()) {
  if (isRasterImageFilename(nomeOriginale)) return "pdfjs";
  return dispositivoTouch(dispositivo) ? "pdfjs" : "iframe";
}
